import { makeStyles, withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { DropzoneArea } from 'material-ui-dropzone';

export const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
            height: theme.spacing(16),
            // fontFamily: 'HelveticaBold',
        },
    },
    smallAdjunto: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    largeBrowser: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.avatar,
    },
    largeMobile: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.avatar,
    },
    smallBrowser: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.subAvatar,
    },
    smallMobile: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        color: theme.white,
        backgroundColor: theme.palette.primary.subAvatar,
    },
    textBrowser: {
        fontSize: '14px',
    },
    textMobile: {
        fontSize: '12px',
    },
    center_item: {
        // margin: 'auto',
        // fontFamily: 'HelveticaBold',
    },
    align_items_middle: {
        display: 'flex',
        alignItems: 'center'
    },
    dividerInset: {
        margin: `5px 0 0 ${theme.spacing(9)}px`,
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 250,
    },
    multiSelect: {
        margin: theme.spacing(0),
        minWidth: 250,
    },
    textField: {
        margin: theme.spacing(0),
        minWidth: 300,
        width: '100%',
    },
    pregDesc: {
        fontWeight: 'bold',
        fontSize: '16px',
        // fontFamily: 'HelveticaBold',
    },
    pregNota: {
        fontWeight: '500',
        fontSize: '13px',
        // fontFamily: 'HelveticaBold',
    },


    
    dropZone: {
        height: '100%',
        fullWidth: 'true',
    },
    previewContainer: {
        container: 'true',
        width: '100%',
        height: '100%',
    },
    preview: {
        //width: '100%',
        //height: '100%',
        //item: 'true',
        xs: '12',
    },
    previewImg: {
        //height: '100%',
        //width: '100%',
    },
    
    //Agregado
    inputStyle: {
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        /*"& .MuiInputBase-input:focus" :{
            borderBottom: '2px solid #4285f4 !important',
        },*/
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        '& label': {
            // fontFamily: 'HelveticaBold',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },
        '& error': {
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root.Mui-error":{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiFormHelperText-root":{
            // fontFamily: 'HelveticaBold',
        }

        /*"& .MuiInput-underline:after":{
            BorderBottom: '2px solid #4285f4',
        }*/
        //borderBottom: '1px solid #4285f4 !important',
    },

    selectStyle: {
        // fontFamily: 'HelveticaBold',
        "& .MuiInputBase-input" :{
            // fontFamily: 'HelveticaBold',
        },
        "& .MuiInput-underline:after" :{
            borderBottom: '2px solid #4285f4 !important',
        },
        //Color del label con el foco
        '& label.Mui-focused': {
          color: '#4285f4',
        },

        "& .MuiFormHelperText-root.Mui-error": {
            // fontFamily: 'HelveticaBold',
        },
    },
    radioStyle: {
        // fontFamily: 'HelveticaBold',
        "& .MuiTypography-body1" :{
            // fontFamily: 'HelveticaBold',
        }
    },
    fontHelvetica: {
        // fontFamily: 'HelveticaBold',
    },

}));


export const DropzoneAreaCustom = withStyles({
    root: {
        minHeight: '180px',
        '& .MuiDropzoneArea-text': {
            fontSize: '1rem',
            marginTop: '10px',
            marginBottom: '10px',
        },
        '& .MuiDropzoneArea-icon': {
            color: '#d32f2f',
            width: '31px',
            height: '31px',
        },
        '& .MuiGrid-spacing-xs-8 > .MuiGrid-item': {
            padding: '20px 32px 10px 32px',
        },
        
    }
})(DropzoneArea);

export const Accordion = withStyles({
    root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    width: '100%',
    boxShadow: 'none',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
    '&$expanded': {
        margin: 'auto',
    },
    },
    expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#eee',
        borderBottom: '1px solid #ddd',
        marginBottom: -1,
        minHeight: 46,
        '&$expanded': {
            minHeight: 46,
        },
        // fontFamily: "HelveticaBold",
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    /*fontFamily: 'HelveticaBold',
    "& .MuiTypography-body1" :{
        fontFamily: 'HelveticaBold',
    },*/
    expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        // fontFamily: "HelveticaBold",
    },
    // fontFamily: 'HelveticaBold',

}))(MuiAccordionDetails);
